// 後端(IIS)單一請求上限為 30,000,000 bytes (約 28.6MB)，扣掉 multipart 開銷每批抓 25MB
const MAX_BATCH_BYTES = 25 * 1024 * 1024;

// 依序分批，加入下一張會超過上限就開新的一批 (單張超過上限時自己一批)
function splitIntoBatches(files, maxBytes) {
  const batches = [];
  let current = [];
  let currentBytes = 0;
  files.forEach((file) => {
    if (current.length > 0 && currentBytes + file.raw.size > maxBytes) {
      batches.push(current);
      current = [];
      currentBytes = 0;
    }
    current.push(file);
    currentBytes += file.raw.size;
  });
  if (current.length > 0) batches.push(current);
  return batches;
}

function getErrorReason(error) {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  return '可能是檔案過大或網路異常，請稍後再試';
}

// 分批依序上傳，uploadBatch(batch) 需回傳 Promise
// 列表是依建立時間新到舊排序，從最後一批開始送，畫面上的順序才會和選取順序相同
// 不會 reject，回傳 { uploadedCount, failedFiles, errorMessage }，全部成功時 errorMessage 為空字串
export default function uploadInBatches(files, uploadBatch, maxBytes = MAX_BATCH_BYTES) {
  const batches = splitIntoBatches(files, maxBytes).reverse();
  const uploadedFiles = [];
  return batches
    .reduce((chain, batch) => chain
      .then(() => uploadBatch(batch))
      .then(() => {
        uploadedFiles.push(...batch);
      }), Promise.resolve())
    .then(() => ({ uploadedCount: files.length, failedFiles: [], errorMessage: '' }))
    .catch((error) => {
      const failedFiles = files.filter((file) => !uploadedFiles.includes(file));
      const reason = getErrorReason(error);
      return {
        uploadedCount: uploadedFiles.length,
        failedFiles,
        errorMessage: uploadedFiles.length > 0
          ? `已上傳 ${uploadedFiles.length} 張，其餘 ${failedFiles.length} 張上傳失敗：${reason}`
          : `上傳失敗：${reason}`,
      };
    });
}
